module.exports = __webpack_public_path__ + "img/icon-project.dc041306.svg";